import BaseService from '@/services/BaseService';

class CategoryService extends BaseService {
    createCategory = (data) => this.post('/create-new-category', data);

    updateCategory = (data, id) => this.post(`/edit-category/${id}`, data);

    getCategoryListOptions = (data) => this.get('/category-list-options', data);

    viewCategory = (id) => this.get(`/view-category/${id}`);

    getCategoryList = (data) => this.post(
        `/get-categories?page=${data.page}&per_page=${data.per_page}`,
        data || {},
    );

    changeCategoryStatus = (data) => this.post('/update-category-publish-status', data);

    deleteCategory = (id) => this.delete(`/delete-category/${id}`);

    getCategoryUnitTypes = () => this.get('/get-product-category-unit-types');
}

export default new CategoryService();
